import { render, staticRenderFns } from "./NewSessionSurveyQuestion.vue?vue&type=template&id=6ba08892&"
import script from "./NewSessionSurveyQuestion.vue?vue&type=script&lang=js&"
export * from "./NewSessionSurveyQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports